import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/globals.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Store/store";
import "./i18n/i18n";
import { SnackbarProvider } from "notistack";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { StyledEngineProvider } from "@mui/material/styles";
import { ColorModeProvider } from "./theme/ColorModeContext";
import { Toaster } from "sonner";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <GoogleOAuthProvider clientId="549448313547-9kkb19p5rn8ea374q4jcmcunhp9n3uqo.apps.googleusercontent.com">
    <Provider store={store}>
      {/* injectFirst -> MUI styles land before Tailwind so utilities can win.
          ColorModeProvider applies the whatspro bridge theme (light/dark) app-wide. */}
      <StyledEngineProvider injectFirst>
        <ColorModeProvider>
          <SnackbarProvider maxSnack={3}>
            <App />
            <Toaster
              position="top-right"
              richColors
              closeButton
              toastOptions={{ style: { fontFamily: "Poppins, sans-serif", borderRadius: "12px" } }}
            />
          </SnackbarProvider>
        </ColorModeProvider>
      </StyledEngineProvider>
    </Provider>
  </GoogleOAuthProvider>
);
